
var id = "changeStore";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"changeStore\">\n<style type=\"text/css\">\n\t#changeStore .st0{fill:none;stroke:#1B60AD;stroke-width:1.5;}\n\t#changeStore .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1B60AD;}\n</style>\n<title>转柜-icon</title>\n<g>\n\t<g id=\"changeStore_编组-4-copy\" transform=\"translate(-24.000000, 0.000000)\">\n\t\t<g id=\"changeStore_转柜-icon\" transform=\"translate(24.000000, 0.000000)\">\n\t\t\t<circle id=\"changeStore_椭圆形\" class=\"st0\" cx=\"8\" cy=\"8\" r=\"7.2\" />\n\t\t\t<g>\n\t\t\t\t<g transform=\"translate(3.000000, 5.000000)\">\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<path class=\"st1\" d=\"M6.2,0l1.4,1.4L5.9,3.2l0.9,0.9l1.8-1.8L10,3.8V0H6.2z M3.8,0H0v3.8l1.4-1.4l2.9,2.9V10h1.2V4.7L2.3,1.4\n\t\t\t\t\t\t\tL3.8,0z\" />\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
